<template>
    <transition name="toast-opacity">
        <div
            class="toast"
            @mouseover="_stopTimer"
            @mouseleave="_startTimer"
            :style="style">
            <div class="toast-message" :class="`toast-${fullOptions.theme}`">
                <span v-html="normalizedMessage"></span>
                <button
                    v-if="fullOptions.closeBtn"
                    class="toast-close"
                    @click="close"></button>
            </div>
        </div>
    </transition>
</template>

<script>
const defaultOptions = {
    theme: 'default',
    duration: 5000,
    closeBtn: true
};

export default {
    props: {
        message: { type: [String, Array], required: true },
        position: { type: Number, required: true },
        onDestroy: { type: Function, required: true },
        options: { type: Object }
    },

    computed: {
        normalizedMessage() {
            if (Array.isArray(this.message)) {
                return this.message.join(' ');
            }
            return this.message;
        },

        style() {
            return `transform: translateY(+${this.position * 100}%)`;
        },

        fullOptions() {
            return Object.assign({}, defaultOptions, this.options);
        }
    },

    data() {
        return {
            visible: false,
            timer: null
        };
    },

    methods: {
        close() {
            this._clearTimer();
            this.$nextTick(() => {
                if (this.onDestroy && typeof this.onDestroy === 'function') {
                    this.onDestroy();
                }
            });
        },

        _startAutoDestroy() {
            this._clearTimer();

            this.timer = setTimeout(() => {
                this.close();
            }, this.fullOptions.duration);
        },

        _clearTimer() {
            if (this.timer) {
                clearTimeout(this.timer);
            }
        },

        _startTimer() {
            this._startAutoDestroy();
        },

        _stopTimer() {
            this._clearTimer();
        }
    },

    mounted() {
        setTimeout(() => {
            this.visible = true;
        }, 50);

        this._startAutoDestroy();
    },

    unmounted() {
        this._clearTimer();
    }
};
</script>
